export default __webpack_public_path__ + "static/media/img--design-7.af0d4906.jpg";